import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppEntrySection from './components/AppEntrySection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AppEntrySection />
        <CardsSection />
        <MediaSection />
        <AboutSection />
        <TopicsSection />
        <FaqSection />
        <IndexSection />
        <FeaturesSection />
        <CarouselSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}